import React from "react";
import { Button, Form, Input, message } from "antd";
import { useSelector } from "react-redux";


const AdminContact = () => {
    const [messageApi] = message.useMessage();
    const success = () => {
        messageApi.open({
            type: "success",
            content: "Data Loaded Successfully",
        });
    };

    const { portfolioData } = useSelector((state) => state.root);
    const { detail } = portfolioData || {}; // Use optional chaining

    const onFinish = (value) => {
        console.log(value);
    };
    return (
        <>
            <div>

                <div className="px-5 py-2 flex flex-col gap-3">
                    <p className="text-xl font-bold">Add Contact Details</p>
                    <Form
                        onFinish={onFinish}
                        layout="vertical"
                        initialValues={detail}
                        style={{ width: 550 }}
                        variant="filled">
                        <Form.Item label="Full Name" name="name" className="font-semibold">
                            <Input className=" h-[40px]" placeholder="Enter your name" />
                        </Form.Item>
                        <Form.Item
                            label="Gender"
                            name="gender"
                            className="font-semibold">
                            <Input className=" h-[40px]" placeholder="Male/Female" />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            className="font-semibold">
                            <Input
                                className=" h-[40px]"
                                type="email"
                                placeholder="Enter Email Address"
                            />
                        </Form.Item>
                        <Form.Item label="Phone Number" name="phone" className="font-semibold">
                            <Input className=" h-[40px]" type="tel" placeholder="+92xxxxxxxxxx" />
                        </Form.Item>
                        <Form.Item
                            label="Location"
                            name="location"
                            className="font-semibold">
                            <Input className=" h-[40px]" placeholder="Enter Location here." />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                className="h-[40px] float-right bg-transparent hover:bg-primary text-primary-700 font-semibold hover:text-white py-2 px-4 border border-primary hover:border-transparent rounded"
                                type="sumbit"
                                onClick={success()}>
                                Update
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </>
    )
}

export default AdminContact
